/**
 * KVKK Uyumlu İsim Maskeleme
 * İsim ve soyismin ilk harfi korunur, geri kalan kısmı *** ile maskelenir.
 * Örnek: "Ali asd" -> "A*** A***"
 * Örnek: "jhhjg jklhkjh" -> "J*** J***"
 */
export function maskKvkkName(name?: string): string {
  if (!name || !name.trim()) return '***';
  return name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => {
      const first = word.charAt(0).toLocaleUpperCase('tr-TR');
      return `${first}***`;
    })
    .join(' ');
}
